import { createFileRoute, useNavigate } from "@tanstack/react-router";
import RecipeEditor from "@/features/inventory/RecipeEditor";
import type { InvRecipeId } from "@brewbase/db/types";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/inventory/recipes/$recipeId")({
  parseParams: (p) => ({ recipeId: Number(p.recipeId) as InvRecipeId }),
  component: RecipeEditorPage,
});

function RecipeEditorPage() {
  const { recipeId } = Route.useParams();
  const navigate = useNavigate();
  return (
    <div className="container mx-auto p-4">
      <RecipeEditor recipeId={recipeId} />
    </div>
  );
}
